export enum BookingStatus {
    cancelled = 'cancelled',
    confirmed = 'confirmed',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    visit_started = 'visit_started',
    visited = 'visited',
    unallocated = 'unallocated',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    partially_unallocated = 'partially_unallocated',
}
